export default "__VITE_ASSET__BfM2Dwn___"